import { Row, Col } from 'antd'
import MarketplaceAvailabilitiesTable from '../../../Components/Table/MarketplaceAvailabilities'
import { useAppSelector } from '../../../hooks'

function MarketplaceAvailabilities() {
  const articleSelected = useAppSelector(state => state.present.articleDetail.articleSelected)
  const enableAllVariant = useAppSelector(state => state.present.quantities.value.enableAllVariant)
  const marketplaceAvailabilitiesDatasource = useAppSelector(
    state => state.present.articleDetail.articleSelected.marketplaceAvailabilities,
  )
  const isMarketplaceAvailabilitiesEnable = useAppSelector(
    state => state.present.configuration.isMarketplaceAvailabilitiesEnable,
  )
  const workspaceMarketplaceAvailabilitiesVisible = useAppSelector(
    state => state.present.configuration.workspaceMarketplaceAvailabilitiesVisible,
  )

  const isArticleSelectedAndDataFetched = articleSelected.fetchedMarketplaceAvailabilities
  const hasMarketplaceResults = marketplaceAvailabilitiesDatasource && marketplaceAvailabilitiesDatasource.length !== 0

  return isMarketplaceAvailabilitiesEnable &&
    workspaceMarketplaceAvailabilitiesVisible &&
    !enableAllVariant &&
    hasMarketplaceResults &&
    isArticleSelectedAndDataFetched ? (
    <Row className=' pa-2'>
      <Col span={24} className='overflow-hidden overflow-x-auto  custom-scroll'>
        <MarketplaceAvailabilitiesTable />
      </Col>
    </Row>
  ) : null
}

export default MarketplaceAvailabilities
